export const vsLookupManagementServiceName = "machineLookupManagementService";
export const vsLookupManagementServiceProviderName = `${vsLookupManagementServiceName}Provider`;
